export class ConsignmentConfig {
  prefixConsignment: string = 'CS/{year}/';
  consignmentHeader: string = '';
  consignmentFooter: string = '';
  additionalIntakeText: string = '';
  additionalReturnText: string = '';
  additionalPayoutStatementText: string = '';
}
